<div class="fixed-bottom bg-light cookie-acceptance-container" [class.show]="showPolicysAcceptance$ | async">
  <div class="container-fluid">
    <div class="row p-4">
      <div class="col-md-6 col-sm-12 d-flex align-items-center text-justify">
        <p>
          Ao acessar e utilizar nosso site, é fundamental que você aceite nossas políticas de segurança da informação e
          de privacidade. Essas políticas são projetadas para proteger seus dados pessoais e garantir a
          confidencialidade, integridade e disponibilidade das informações que você compartilha conosco. Ao concordar
          com essas políticas, você está ajudando a manter um ambiente online seguro e transparente para todos os
          usuários. Nossa prioridade é sua segurança e privacidade, e sua cooperação ao aceitar essas políticas é
          essencial para garantir uma experiência positiva e segura em nosso site.
        </p>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="d-flex align-items-center flex-column">
          <a
            *ngIf="route_seguranca.startsWith('http')"
            [attr.href]="route_seguranca"
            target="_blank"
            mat-raised-button
            class="w-350 mt-3"
            color="secondary"
          >
            Política de segurança da informação
          </a>
          <a
            *ngIf="!route_seguranca.startsWith('http')"
            [routerLink]="route_seguranca"
            mat-raised-button
            class="w-350 mt-3"
            color="secondary"
          >
            Política de segurança da informação
          </a>
          <a
            *ngIf="route_privacidade.startsWith('http')"
            [attr.href]="route_privacidade"
            target="_blank"
            mat-raised-button
            class="w-350 mt-3"
            color="secondary"
          >
            Política de privacidade
          </a>
          <a
            *ngIf="!route_privacidade.startsWith('http')"
            [routerLink]="route_privacidade"
            mat-raised-button
            class="w-350 mt-3"
            color="secondary"
          >
            Política de privacidade
          </a>
          <button mat-raised-button class="w-350 mt-3" color="primary" (click)="onAgreeClick()">
            Concordar e fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
